module.exports = __webpack_public_path__ + "static/media/16.f6866686.jpg";